export function isValidObjectId(value: string | undefined): boolean {
  return value?.length === 24;
}
